<template>
  <div :class="showBorder==true?'noneData':'noneData noneData-border'">
    <img v-if="isNoPermission == true" src="../../assets/images/jurisdiction.png" />
    <i v-else class="iconfont">&#xe60c;</i>
    <p>{{ title || '还没有相关数据' }}</p>
  </div>
</template>

<script>
export default {
  props: {
    // 是否打开
    title: {
      type: String,
      default: String
    },
    // 是否需要边框
    showBorder: {
      type: Boolean,
      default: Boolean
    },
    // 是否需要边框
    isNoPermission: {
      type: Boolean,
      default: Boolean
    },
  },

};
</script>

<style>
.noneData {
    border-radius: 4px;
    padding: 30px 0;
}
.noneData-border{
 border: 1px solid #eee;
}
.noneData .iconfont {
    font-family: "iconfont" !important;
    font-size: 40px;
    font-style: normal;
    font-weight: 100 !important;
    color: #cecece;
    display: block;
    text-align: center;
}
.noneData p {
    color: #bebebe;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    height: 44px;
    line-height: 44px;
}
.noneData img {
  width: 80px;
  display: block;
  margin: 0 auto;
}
</style>
